export default "__VITE_ASSET__19f4baaa__"